export default __webpack_public_path__ + "static/media/Myracle tutorial_v1.0_BR_low quality.f91ca74f.mp4";